import { Share } from "./share";
import { ShareTracking } from "./shareTracking";


export class ShareInits {
    constructor() {
        this.initMap();
    }

    initMap() {
        //new Share();
        new ShareTracking();
    }
}
